<template>
  <v-dialog v-model="show" activator="parent" content-class="sela-dialog" v-if="item">
    <div class="sela-dialog-card" style="height: 85% !important">
      <div class="sela-dialog-card-header">
        <v-icon class="" color="white" size="36" style="cursor: pointer" @click.stop="show = false"> mdi-close </v-icon>
      </div>
      <DialogLogo />

      <v-img class="sela-dialog-card-content" :src="item.imageUrl" :lazy-src="item.thumbnailUrl" :key="item.imageUrl">
        <template v-slot:placeholder>
          <div class="d-flex align-center justify-center fill-height">
            <v-progress-circular color="white" indeterminate></v-progress-circular>
          </div>
        </template>
      </v-img>

      <div class="sela-dialog-card-footer">
        <v-btn outlined class="sela deactivate largeText" @click="shareImage()" width="40%"> 친구에게 공유하기 </v-btn>
        <v-btn outlined class="sela deactivate largeText" @click="writeReview()" width="28%"> {{ hasReview ? "리뷰수정" : "리뷰쓰기" }} </v-btn>
        <v-btn outlined class="sela largeText" @click="openUrlForDownload()" width="28%"> 저장 </v-btn>
      </div>
    </div>

    <ReviewWriteDialog :visible="reviewDialog" :item="item" @close="reviewDialog = false" :key="item.id" />
  </v-dialog>
</template>
<script>
import ReviewWriteDialog from "./ReviewWriteDialog"
import DialogLogo from "@/views/components/DialogLogo"

export default {
  components: {
    ReviewWriteDialog,
    DialogLogo,
  },

  props: {
    item: Object,
    visible: Boolean,
  },

  data: () => ({
    reviewDialog: false,
    hasReview: false,
  }),

  computed: {
    show: {
      get() {
        return this.visible
      },
      set(newValue) {
        if (newValue === false) {
          this.$emit("close")
        }
      },
    },
  },

  mounted() {
    this.$http
      .post("/api/review/select/request", {
        params: {
          requestId: this.item.id,
        },
      })
      .then((res) => {
        if (res.data.length > 0) {
          this.hasReview = true
        } else {
          this.hasReview = false
        }
      })
  },

  methods: {
    async shareImage() {
      await this.$shareLink(this.item.imageUrl)
    },

    writeReview() {
      this.reviewDialog = true
    },

    downloadImage() {
      const a = document.createElement("a")
      a.href = this.item.imageUrl
      a.download = this.item.filename
      a.click()
    },
    openUrlForDownload() {
      window.open("https://front.lafia-studio.com/imageViewer-v1.html?image=" + this.item.filename, "_blank")
    },
  },
}
</script>
